import {createUseStyles} from "react-jss";

export const useStyles = createUseStyles({
    contactsAndSocialContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "@media (max-width: 1200px)": {
            flexDirection: "column",
            alignItems: "flex-start"
        }
    }
});
